import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';
import ApplicationImg from '@/assets/images/avantages/appli-mobile-sentidrive.png'
import SentidriveLogo from '@/assets/images/avantages/sentidrive-home.png'

const Sentidrive = () => {
    return (
        <div className="mt-6">
            <Card>
                <CardContent className="p-6">
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
                        <div className="md:col-span-4">
                            <img src={ApplicationImg} alt="Application" className="w-full rounded-lg" />
                        </div>
                        <div className="md:col-span-8">
                            <img src={SentidriveLogo} alt="Sentidrive" className="max-h-12" />
                            <h3 className="text-primary font-bold mt-6 text-lg">
                                Remise de 15% sur l'un des traceurs développés par Sentidrive : Sentinelle Dashcam, Sentinelle Mini+ ou Sentinelle Air+.
                            </h3>
                            <p className="mt-6 text-muted-foreground">
                                L'application Sentidrive, reliée aux traceurs GPS Sentidrive, vous permet de sécuriser facilement votre véhicule. En cas de vol, il vous suffit de le déclarer sur l'application. Vous serez alors rappelé par un membre de l'équipe Sentidrive sous 15 minutes afin de mettre en place la recherche de votre véhicule en partenariat avec les forces de l'ordre.
                            </p>

                            <p className="mt-6 text-muted-foreground">Ses fonctionnalités sont nombreuses :</p>
                            <ul className="mt-1 space-y-1 text-sm text-muted-foreground list-disc list-inside">
                                <li>Géolocalisation en temps réel</li>
                                <li>Détection de vibrations</li>
                                <li>Historique de trajets</li>
                                <li>Et bien plus encore…</li>
                            </ul>

                            <p className="mt-6 font-semibold">Comment en bénéficier ?</p>
                            <ol className="mt-2 space-y-2 text-sm text-muted-foreground list-decimal list-inside">
                                <li>Rendez vous sur le site <a href="https://sentidrive.com/avantage-april/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">https://sentidrive.com/avantage-april/</a></li>
                                <li>Choisissez votre modèle de traceur Sentinelle</li>
                                <li>Validez votre commande et payez en ligne. Une fois le paiement effectué, vous allez recevoir un email de confirmation demandant votre plaque d'immatriculation afin de vérifier votre éligibilité.</li>
                                <li>Après vérification du contrat, vous recevrez votre remboursement par virement bancaire sous 24 à 48h.</li>
                            </ol>

                            <p className="mt-6 text-muted-foreground">
                                Bonne route avec APRIL&nbsp;Moto&nbsp;&&nbsp;SENTIDRIVE&nbsp;!
                            </p>

                            <Button asChild className="mt-6 cursor-pointer">
                                <a target="_blank" rel="noopener noreferrer" href="https://sentidrive.com/avantage-april/" className="no-underline text-white" aria-label="Profitez de l'offre Sentidrive">
                                    <ExternalLink className="w-4 h-4" aria-hidden="true" />
                                    Profitez de l'offre
                                </a>
                            </Button>
                        </div>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default Sentidrive;
